import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';
import { ADD, EDIT, ERR, TEXT, VIEW } from '../../../common/common';
import LevelChoose from '../../Components/LevelChoose';
import Participate from '../../Components/Participate';
import Toast from '../../Layout/components/Toast';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class AddMatter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            number: "",
            numberCopy: "",
            name: "",
            note: "",
            showMsg: false,
            showToast: false,
            toastMsg: "",
            toastState: "",

            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            number,
            name,
            note,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const { caseNumber } = this.props;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                <div className="title">Case Info</div>
                <TextField
                    disabled={true}
                    className="textField"
                    id="case"
                    label="Case Number"
                    value={caseNumber}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Matter Info</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="number"
                    label="Matter Number"
                    value={number}
                    onChange={e => this.handleChange(e, 'number')}
                    margin="dense"
                    variant="outlined"
                // error={this.validator(ERR, "number")}
                // helperText={this.validator(TEXT, "number")}
                />
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="outlined-name"
                    label="Matter Name"
                    value={name}
                    onChange={e => this.handleChange(e, 'name')}
                    margin="dense"
                    variant="outlined"
                // error={this.validator(ERR, "name")}
                // helperText={this.validator(TEXT, "name")}
                />
                <div className="title">Notes</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="outlined-multiline-static"
                    label="Matter Notes"
                    multiline
                    rows="3"
                    value={note}
                    onChange={e => this.handleChange(e, 'note')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Originating Department / Team / Attorney</div>
                <LevelChoose
                    ref={(child) => { this.levelChoose = child }}
                    officeName={this.getHandleData("office")}
                    deptId={this.getHandleData("dept")}
                    teamId={this.getHandleData("team")}
                    memberId={this.getHandleData("member")}
                    state={this.props.state}
                    isDisabled={this.isDisabled()}
                    editable={!this.isDisabled()}
                    viewData={this.getHandleData("view")}
                />
                <div className="title">Participants</div>
                <Participate
                    ref={(child) => { this.participate = child }}
                    userList={this.userFormat()}
                    state={this.props.state}
                    addBtnName="add another participant"
                />
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        console.log(data)
        if (state === VIEW || state === EDIT) {
            const number = data.number;
            const numberCopy = data.number;
            const name = data.name;
            const note = data.note ? data.note : "";
            this.setState(() => ({
                number,
                numberCopy,
                name,
                note,
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const { caseId } = this.props;
        const {
            number,
            numberCopy,
            name,
            note,
        } = this.state;
        let teamObj = this.levelChoose.getData();
        let userObj = {};
        userObj.handler_id = teamObj.handler_id;
        userObj.handler_team_id = teamObj.handler_team_id;
        userObj.is_origin_attorney = true;
        const attorneyArr = [userObj];
        const asObjFormat = this.editAttorney(attorneyArr);//结构：{addHandler,delHanlder}
        const psObjFormat = this.participate.getData();//结构：{addMembers,delMembers}
        const handlers = this.mergeHandlers(asObjFormat, psObjFormat);
        let obj = {
            case_id: caseId,
            number: (number !== numberCopy) ? number : null,
            name,
            note,
            handlers,
        }
        if (this.verifyData(obj)) {
            this.props.handleCreate(obj);
        }
    }
    verifyData(obj) {
        const { state } = this.props;
        const caseId = obj.case_id;
        const number = obj.number;
        const name = obj.name;
        const handlers = obj.handlers;
        const addMembers = handlers.addMembers ? handlers.addMembers : [];
        let isPass = true;
        console.log(caseId, number, name, handlers)
        if (state === ADD) {
            if (!number) {
                this.showToast("Please fill in the matter number", "warning");
                isPass = false;
            } else if (!name) {
                this.showToast("Please fill in the matter name", "warning");
                isPass = false;
            } else if (addMembers.length > 0) {
                const handler_id = addMembers[0].handler_id;
                if (!handler_id) {
                    this.showToast("Please choose an attorney", "warning");
                    isPass = false;
                }
            } else if (addMembers.length <= 0) {
                this.showToast("Please choose an attorney", "warning");
                isPass = false;
            }
        } else if (state === EDIT) {
            if (number === "") {
                this.showToast("Please fill in the matter number", "warning");
                isPass = false;
            } else if (!name) {
                this.showToast("Please fill in the matter name", "warning");
                isPass = false;
            } else if (addMembers.length > 0) {
                const handler_id = addMembers[0].handler_id;
                if (!handler_id) {
                    this.showToast("Please choose an attorney", "warning");
                    isPass = false;
                }
            }
        }
        return isPass;
    }
    validator(type, name) {
        const { showMsg } = this.state;
        const value = this.state[name];
        if (showMsg) {
            if (type === ERR) {
                return value ? false : true;
            } else {
                return value ? "" : "This field is required."
            }
        } else {
            const value = type === ERR ? false : "";
            return value;
        }
    }
    mergeHandlers(attorneyArr, participantArr) {
        const aAddMembers = attorneyArr.addHandler;
        const pAddMembers = participantArr.addMembers;
        const aDelMembers = attorneyArr.delHandler;
        const pDelMembers = participantArr.delMembers;
        const addMembers = aAddMembers.concat(pAddMembers);
        const delMembers = aDelMembers.concat(pDelMembers);
        return { addMembers, delMembers };
    }
    editAttorney(handler) {
        const addHandler = handler;
        const delHandler = this.extDelAttorney();
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = (delHandler.length > 0) ? delHandler[0].handler_id : "";
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = (delHandler.length > 0) ? delHandler[0].handler_team_id : "";
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                return { addHandler: [], delHandler: [] };
            } else {
                return { addHandler, delHandler }
            }
        }
    }
    extDelAttorney() {
        const { data } = this.props;
        if (!data) return [];
        const handlers = data.handler;
        if (!handlers) return [];
        let handlerObj = [];
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                let newObj = {};
                newObj.handler_id = obj.user.id;
                newObj.handler_team_id = obj.team.id;
                newObj.is_origin_attorney = obj.is_origin_attorney;
                handlerObj.push(newObj);
                return handlerObj;
            }
        }
        return [];
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    getHandleData(name) {
        const handlers = this.extAOrP("attorney");
        if (handlers.length <= 0) return "";
        const obj = handlers[0];
        const userObj = obj.user;
        const deptObj = obj.team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        } else if (name === "view") {
            return obj;
        }
    }
    userFormat() {
        const users = this.extAOrP();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let obj = {};
                obj.handler_id = userObj.user.id;
                obj.handler_team_id = userObj.team ? userObj.team.id : null;
                obj.is_origin_attorney = userObj.is_origin_attorney;
                userList.push(obj);
            }
            return userList;
        }
        return [];
    }
    extAOrP(type) {
        const { data } = this.props;
        if (!data) return [];
        let attorneyArr = [];
        let participateArr = [];
        const handlerArr = data.handler;
        if (!handlerArr) return [];
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyArr.push(obj);
            } else {
                participateArr.push(obj);
            }
        }
        if (type === "attorney") {
            return attorneyArr;
        } else {
            return participateArr;
        }
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
}

export default AddMatter;